module.exports = __webpack_public_path__ + "assets/images/numberofChairs-04.d6f743d09eb22014ac82390af5771137.svg";